import React from "react";

export const multiSenderContent = {
  how_to_use_multisender: {
    title: "How to Use TrendPad Multi-Sender",
    content: (
      <>
        <h3>Using TrendPad Multi-Sender</h3>
        <p>
          Follow this step-by-step guide to batch send tokens efficiently using
          TrendPad.
        </p>

        <h4>Step 1: Enter Token Details</h4>
        <p>
          1. Enter the <strong>Contract Address</strong> of the token you wish
          to send.
        </p>
        <img
          src="/docs/multisender/1.png"
          alt="Enter Token Address"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 2: Configure Allocations</h4>
        <p>
          2. Select the <strong>Amount Type</strong>: Choose{" "}
          <strong>Fixed</strong> or <strong>Random</strong>.
        </p>
        <img
          src="/docs/multisender/2.png"
          alt="Select Amount Type"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          3. Enter the <strong>Allocations</strong>. These are the wallet
          addresses where you want to send the tokens.
        </p>
        <img
          src="/docs/multisender/3.png"
          alt="Enter Wallet Addresses"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          4. Type the <strong>Amount</strong> to be allocated. This depends on
          your chosen option (a specific amount for Fixed, or a range for
          Random).
        </p>
        <img
          src="/docs/multisender/4.png"
          alt="Enter Amount"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          5. Click <strong>Generate Allocations</strong>. This will
          automatically allocate the appropriate amounts to the listed
          addresses.
        </p>
        <img
          src="/docs/multisender/5.png"
          alt="Generate Allocations"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 3: Confirmation</h4>
        <p>
          6. Click <strong>Next</strong> and look for the popup in your wallet
          provider. Confirm the action to proceed.
        </p>
        <img
          src="/docs/multisender/6.png"
          alt="Next and Confirm"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 4: Approval & Sending</h4>
        <p>
          7. Select the <strong>Send Option</strong>:
        </p>
        <ul>
          <li>
            <strong>Safe Mode:</strong> Use this for standard tokens.
          </li>
          <li>
            <strong>Unsafe Mode:</strong> Use this for taxes tokens (ensure
            sender is excluded from fees).
          </li>
        </ul>

        <p>
          8. Click the <strong>Approve</strong> button and confirm the approval
          transaction in your wallet provider.
        </p>
        <img
          src="/docs/multisender/8.png"
          alt="Approve Transaction"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          9. Once approved, Click <strong>Submit</strong> to finalize and send
          the tokens.
        </p>

        <h4>Step 5: Transaction Success</h4>
        <p>
          10. After the transaction is successful, you will see a confirmation
          box. You can click the <strong>Send More</strong> button to start
          another batch.
        </p>
        <img
          src="/docs/multisender/9.png"
          alt="Transaction Success"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />
      </>
    ),
  },
};
